/* global Swiper jQuery:false */

/*
 * training tabs
 */
// (function ($) {

// 	"use strict";

// 	$(".q-apps__tabs a").on("click", function(){

// 		var tab = $(this).data("tab");
// 		$(".q-apps__tabs a").removeClass("q-active-tab");
// 		$(this).addClass("q-active-tab");
// 		$(".q-apps__grid--item").addClass("q-tab-hidden");
// 		$(tab).removeClass("q-tab-hidden");

// 	});
// 	var hash = window.location.hash;
// 	if(hash){
// 		$("[data-tab='" + hash + "-tab']").trigger("click");
// 	}


// }(jQuery));


(function ($) {
	"use strict";

	$(".q-apps__tabs a").each(function(){
		var ths = $(this),
			ths_tab = ths.data("tab");
			// eslint-disable-next-line no-unused-vars
			var hash = window.location.hash;
		ths.on("click", function(){
			$('html, body').animate({scrollTop: $('.q-agenda-container').offset().top}, 'slow');
			$(".q-apps__tabs a").removeClass("q-active-tab");
			ths.addClass("q-active-tab");
			if(ths_tab == "all") {
				$(".q-apps__grid--item").removeClass("q-tab-hidden");
			}
			else {
				$(".q-apps__grid--item").addClass("q-tab-hidden");
				$("[data-app=" + ths_tab + "]").removeClass("q-tab-hidden");
			}
		});
	});

	// get URL hash
	var hash = window.location.hash;
	// eslint-disable-next-line no-unused-vars
	var selectorWithoutHash;
	// enable tabs by hash value
	if(hash && hash !== "register"){
		$('html, body').animate({scrollTop: $('.q-agenda-container').top}, 'slow');
		$("[data-tab='" + hash + "-tab']").trigger("click");
	}

}(jQuery));

/*
 * automatically open self-paced overlay based on hash value
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		// get hash value
		var hash = "";
		if (window.location.hash) {
			/* Puts hash in variable, and removes the # character */
			hash = window.location.hash.substring(1);

			if( hash !== "register") {

				/* remove initial slash if it exists */
				hash = hash.indexOf("/") == 0 ? hash.substring(1) : hash;

				// trigger the click on hash selectors

				$("[href='#"+ hash +"']").trigger( "click" );

			}
		}

	});
}(jQuery));


(function () {

	"use strict";

	// init news and events carousel
	new Swiper(".resources-slider-container", {
		slidesPerView: "auto",
		navigation: false,
		pagination: {
			el: '.resources .swiper-pagination',
			type: 'bullets',
		},
		centeredSlides: false,
		spaceBetween: 30
	});

}());

